export const reportUnlockFeatures = [
  'Message-by-message evidence',
  'Exact messages that triggered each pattern',
  'Detailed pattern analysis',
  'Personalized recommendations',
  'Complete conversation breakdown',
  'Downloadable PDF report',
  'Shareable forensic result',
]
